<template>
  <div style="background-color: #f4fbff; height: 100vh">
    <Header
      :leftArrow="true"
      :leftText="''"
      @leftClick="onClickLeft"
      :rightIcons="true"
    >
    </Header>
    <div>
      <van-uploader
        v-model="fileList"
        :before-delete="deleteFile"
        :before-read="beforeRead"
        :preview-size="screenWidth / 3 - 10"
        @delete="updateList"
        :after-read="updateList"
      />
    </div>
<!--    <div style="display: flex; justify-content: center">-->
<!--      <van-button-->
<!--        round-->
<!--        block-->
<!--        type="primary"-->
<!--        native-type="submit"-->
<!--        @click="updateList"-->
<!--        id="mypage_btn"-->
<!--        :color="'#48b2fb'"-->
<!--        style="width: 95%; max-width: 500px"-->
<!--      >-->
<!--        変更する-->
<!--      </van-button>-->
<!--    </div>-->
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import "vant/es/toast/style";
import { Toast } from "vant";
import { BASE_URL } from "@/services/api";

import {
  getWaitBackgroundList,
  updateWaitBackground,
} from "@/services/waitBackground";
import lrz from "lrz";

export default {
  data() {
    return {
      screenWidth: null,
      fileList: [],
      deleteFileList: [],
      patient_id: null,
    };
  },
  components: {
    Header,
  },
  mounted() {
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
    if (this.$route.query.patient_id) {
      this.patient_id = this.$route.query.patient_id;
    }
    this.initImgList();
  },
  created() {},
  methods: {
    async initImgList() {
      this.fileList = [];
      if (this.patient_id) {
        let ret = await getWaitBackgroundList({ patient_id: this.patient_id });
        if (ret.data.code >= 0 && ret.data.data) {
          ret.data.data.forEach((item) => {
            this.fileList.push({
              url: BASE_URL + "/getBackGroundImage/" + item,
            });
          });
        }
      } else {
        let ret = await getWaitBackgroundList();
        if (ret.data.code >= 0 && ret.data.data) {
          ret.data.data.forEach((item) => {
            this.fileList.push({
              url: BASE_URL + "/getBackGroundImage/" + item,
            });
          });
        }
      }
    },
    beforeRead(file) {
      if (Array.isArray(file)) {
        if (this.fileList.length + file.length > 9) {
          Toast("最大9ファイルのアップロード");
          return false;
        }
        // multiple
        try {
          file.forEach((item) => {
            if (item.size >= 3 * 1024 * 1024) {
              throw new Error("画像の保存に失敗しました。サイズ3MB以下の画像を1枚ずつ選んで操作してください。");
            }
            if (item.name.includes(",")) {
              throw new Error("ファイル名に','を含めることはできません!");
            }
          });
        } catch (e) {
          Toast(e.message);
          return false;
        }
      } else {
        if (file.size >= 3 * 1024 * 1024) {
          Toast("画像の保存に失敗しました。サイズ3MB以下の画像を1枚ずつ選んで操作してください。");
          return false;
        }
        if (this.fileList.length + 1 > 9) {
          Toast("最大9ファイルのアップロード");
          return false;
        }
        // single
        if (file.name.includes(",")) {
          Toast("ファイル名に','を含めることはできません。");
          return false;
        }
      }
      return true;
    },
    deleteFile(file) {
      if (file.url) {
        const index = this.fileList.findIndex(
          (obj) => obj.url && obj.url == file.url
        );
        if (index !== -1) {
          let list = this.fileList[index].url.split("/");
          this.deleteFileList.push(list[list.length - 1]);
        }
      }
      return true;
    },
    async updateList() {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
      });
      let formData = new FormData();
      let existFileList = [];
      // 收集所有压缩 Promise
      const compressPromises = this.fileList.map((item) => {
        if (item.file) {
          const quality = this.calcQuality(item.file.size);
          return this.compressImg(item.file, quality).then((compressedFile) => {
            formData.append("files[]", compressedFile,item.file.name);
          });
        } else if (item.url) {
          const list = item.url.split("/");
          existFileList.push(list[list.length - 1]);
        }
        return Promise.resolve();
      });
      // 等待所有压缩完成
      await Promise.all(compressPromises);
      if (this.patient_id) {
        formData.append("patient_id", this.patient_id);
      }
      formData.append("existFileList", existFileList.join(","));
      formData.append("deleteFileList", this.deleteFileList.join(","));
      let res = await updateWaitBackground(formData);
      if (res && res.data.code >= 0) {
        await this.initImgList();
        Toast.clear();
        Toast.success("変更に成功しました");
        // window.location.reload();
      } else {
        Toast.clear();
        Toast.fail("変更に失敗しました");
      }
    },
    onClickLeft() {
      history.back();
    },
    compressImg(file, quality) {
      return lrz(file, { quality: quality })
        .then((rst) => {
          return rst.file;
        })
        .catch((err) => {
          console.error("压缩失败:", err);
          throw err;
        });
    },
    calcQuality(size) {
      const targetSize = 1048576; // 1M大小
      let quality = 1;

      if (size < targetSize) {
        // 如果文件小于1M，保持原始质量
        return quality;
      } else {
        // 计算出压缩质量，使得压缩后文件大小为1M
        quality = targetSize / size;
      }
      // 确保质量在0.1到1之间
      return Math.max(Math.min(quality, 1), 0.1);
    },
  },
  watch: {
    screenWidth: function (n, o) {},
  },
};
</script>

<style scoped>
#mypage_btn {
  width: 100%;
  height: 54px;
  background: #aacbe7;
  border-radius: 8px;
  color: #fff;
  display: block;
  font-size: 20px;
  line-height: 54px;
  text-align: center;
  margin-top: auto;
}
#mypage_btn.possible {
  background: #3b82c4;
  pointer-events: auto;
}
</style>
